import axios from 'axios';
import { isBoolean, isEmpty, isNumber } from 'lodash';
import queryString from 'querystring';

import { ACCESS_TOKEN } from '@/utils/user/constants';

// import userManager from '@/state/userManager';

import axiosInstance from '../axiosInstance';

const getReqUrl = (url, q) =>
  `${url}${q ? `?${queryString.stringify(q)}` : ''}`;

export const { token: cancelToken, cancel: cancelRequest } =
  axios.CancelToken.source();

/**
 * Sends request to the specified URL using axios.
 *
 * @param {String} url URL to send the request.
 * @param {Object} queryParams Object to be parsed in the url as query parameters.
 * @param {Object} requestParams Params to modify the axios request object.
 * @param {Function} requestParams.requestHandler Custom request handler to be used after the request is done. Defaults to the './defaultRequestHandler' export.
 * @param {Object} requestParams.contentType Content-Type of the request. Defaults to 'application-json'.
 * @param {Object} requestParams.authorization Authorization header of the request. Defaults to the token stored in the localStorage.
 */
const baseRequest = async (
  url,
  queryParams,
  { contentType = 'application/json', ...customOptions },
) => {
  const headers = { ...customOptions?.options?.headers };

  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  const accessToken = localStorage.getItem(ACCESS_TOKEN);

  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`; // eslint-disable-line
  }

  const options = {
    ...customOptions?.options,
    ...customOptions,
    cancelToken,
    headers,
  };

  let reqUrl = url;

  if (!isEmpty(queryParams)) {
    const paramsChecked = Object.keys(queryParams).reduce((acc, curr) => {
      const value = queryParams[curr];

      if (isEmpty(value) && !isNumber(value) && !isBoolean(value)) return acc;

      return { ...acc, [curr]: value };
    }, {});

    reqUrl = getReqUrl(url, paramsChecked);
  }

  return axiosInstance(reqUrl, options);
};

export default baseRequest;
